/* Stylised device mockups for the before/after slider and the "Pick a mode" configurator.
   Placeholders until real product photography exists (brand book: black studio, lime paint marks). */
(function () {
  const LIME = '#D7FF00', WHITE = '#F7F7F2', BLACK = '#050505';

  // Shapes are unioned into one silhouette; box is the silhouette's bounding box for laying out artwork.
  const DEVICES = {
    earbuds: {
      box: { x: 70, y: 105, w: 260, h: 200 },
      shapes: [{ t: 'rect', x: 70, y: 105, w: 260, h: 200, rx: 78 }],
      details: (c) => `
        <path d="M76 170 H324" stroke="${c.seam}" stroke-width="3"/>
        <circle cx="200" cy="236" r="5" fill="${c.led}"/>`,
    },
    gamepad: {
      box: { x: 46, y: 118, w: 308, h: 210 },
      shapes: [
        { t: 'rect', x: 62, y: 118, w: 276, h: 128, rx: 60 },
        { t: 'ellipse', cx: 104, cy: 240, rx: 52, ry: 84, rot: 16 },
        { t: 'ellipse', cx: 296, cy: 240, rx: 52, ry: 84, rot: -16 },
      ],
      // Asymmetric layout (stick top-left, d-pad lower; buttons top-right, stick lower) like a real controller
      details: (c) => `
        <circle cx="116" cy="168" r="22" fill="${c.stick}" stroke="${c.seam}" stroke-width="3"/>
        <path d="M160 204 v36 M142 222 h36" stroke="${c.btn}" stroke-width="12" stroke-linecap="round"/>
        <circle cx="284" cy="150" r="8" fill="${c.btn}"/><circle cx="303" cy="168" r="8" fill="${c.btn}"/>
        <circle cx="265" cy="168" r="8" fill="${c.btn}"/><circle cx="284" cy="186" r="8" fill="${c.btn}"/>
        <circle cx="240" cy="222" r="22" fill="${c.stick}" stroke="${c.seam}" stroke-width="3"/>`,
    },
    phone: {
      box: { x: 118, y: 36, w: 164, h: 328 },
      shapes: [{ t: 'rect', x: 118, y: 36, w: 164, h: 328, rx: 34 }],
      details: (c) => `
        <rect x="134" y="52" width="72" height="80" rx="20" fill="${c.stick}" stroke="${c.seam}" stroke-width="3"/>
        <circle cx="155" cy="74" r="11" fill="${BLACK}" stroke="${c.seam}" stroke-width="3"/>
        <circle cx="155" cy="110" r="11" fill="${BLACK}" stroke="${c.seam}" stroke-width="3"/>
        <circle cx="186" cy="92" r="11" fill="${BLACK}" stroke="${c.seam}" stroke-width="3"/>`,
    },
    // IQOS ILUMA: pebble charger with the door along its left side, holder standing beside it
    pocket: {
      box: { x: 162, y: 44, w: 128, h: 312 },
      shapes: [{ t: 'rect', x: 162, y: 44, w: 128, h: 312, rx: 46 }],
      details: (c) => `
        <rect x="160" y="58" width="28" height="262" rx="14" fill="${c.seam}" stroke="${c.seam}" stroke-width="2"/>
        <rect x="104" y="96" width="36" height="260" rx="18" fill="${c.stick}" stroke="${c.outline}" stroke-width="3"/>
        <path d="M104 116 H140" stroke="${c.seam}" stroke-width="2"/>
        <rect x="113" y="168" width="18" height="34" rx="9" fill="#050505" stroke="${c.seam}" stroke-width="2"/>
        <circle cx="119" cy="180" r="2" fill="#F7F7F2"/><circle cx="125" cy="180" r="2" fill="#F7F7F2"/>
        <circle cx="119" cy="190" r="2" fill="#F7F7F2"/><circle cx="125" cy="190" r="2" fill="#F7F7F2"/>`,
    },
  };

  const DARK = { outline: '#34342f', seam: 'rgba(247,247,242,.16)', btn: 'rgba(247,247,242,.24)', stick: '#151513', led: LIME };
  const LIGHT = { outline: '#8d8d87', seam: 'rgba(5,5,5,.16)', btn: 'rgba(5,5,5,.22)', stick: '#e2e2dc', led: BLACK };

  // Deterministic randomness so a device/mode always looks the same.
  function rng(seedStr) {
    let h = 1779033703 ^ seedStr.length;
    for (let i = 0; i < seedStr.length; i++) { h = Math.imul(h ^ seedStr.charCodeAt(i), 3432918353); h = (h << 13) | (h >>> 19); }
    let a = h >>> 0;
    return function () {
      a |= 0; a = (a + 0x6D2B79F5) | 0;
      let t = Math.imul(a ^ (a >>> 15), 1 | a);
      t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
      return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
    };
  }
  const f = (n) => Math.round(n * 10) / 10;

  function shapeEl(s, attrs) {
    if (s.t === 'rect') return `<rect x="${s.x}" y="${s.y}" width="${s.w}" height="${s.h}" rx="${s.rx}" ${attrs}/>`;
    return `<ellipse cx="${s.cx}" cy="${s.cy}" rx="${s.rx}" ry="${s.ry}" transform="rotate(${s.rot} ${s.cx} ${s.cy})" ${attrs}/>`;
  }

  function crown(cx, cy, s, color, sw) {
    const p = [[-1, .55], [-1, -.35], [-.5, .1], [0, -.6], [.5, .1], [1, -.35], [1, .55]]
      .map(([x, y]) => `${f(cx + x * s)} ${f(cy + y * s)}`).join(' L ');
    return `<path d="M${p} Z" fill="none" stroke="${color}" stroke-width="${f(sw)}" stroke-linejoin="round"/>`;
  }

  function squiggle(b, y, amp, color, sw) {
    const x0 = b.x + b.w * 0.14, x1 = b.x + b.w * 0.86, n = 5, step = (x1 - x0) / n;
    let d = `M${f(x0)} ${f(y)}`;
    for (let i = 0; i < n; i++) d += ` q ${f(step / 2)} ${f(i % 2 ? amp : -amp)} ${f(step)} 0`;
    return `<path d="${d}" fill="none" stroke="${color}" stroke-width="${f(sw)}" stroke-linecap="round"/>`;
  }

  function splat(cx, cy, r, color, R) {
    let s = `<circle cx="${f(cx)}" cy="${f(cy)}" r="${f(r)}" fill="${color}"/>`;
    for (let i = 0; i < 9; i++) {
      const a = R() * Math.PI * 2, d = r * (1.15 + R() * 0.8), rr = r * (0.06 + R() * 0.16);
      s += `<circle cx="${f(cx + Math.cos(a) * d)}" cy="${f(cy + Math.sin(a) * d)}" r="${f(rr)}" fill="${color}"/>`;
    }
    return s;
  }

  const MODES = {
    plain: { body: '#d2d2cc', light: true, art: () => '' },

    street: {
      body: '#0c0c0b', light: false,
      art(b, R) {
        const band = b.y + b.h * 0.27;
        let s = `<rect x="${b.x - 10}" y="${b.y - 10}" width="${b.w + 20}" height="${f(band - b.y + 10)}" fill="${LIME}"/>`;
        for (let i = 0; i < 6; i++) {
          const w = b.w * (0.035 + R() * 0.03), x = b.x + b.w * (0.08 + i * 0.16) + R() * b.w * 0.05, len = b.h * (0.06 + R() * 0.3);
          s += `<rect x="${f(x)}" y="${f(band - 2)}" width="${f(w)}" height="${f(len)}" fill="${LIME}"/>`
            + `<circle cx="${f(x + w / 2)}" cy="${f(band - 2 + len)}" r="${f(w * 0.62)}" fill="${LIME}"/>`;
        }
        for (let i = 0; i < 22; i++) {
          s += `<circle cx="${f(b.x + R() * b.w)}" cy="${f(band + R() * b.h * 0.3)}" r="${f(0.8 + R() * 2.6)}" fill="${LIME}"/>`;
        }
        // white tag, tilted so it reads as a hand-thrown mark
        const ty = b.y + b.h * 0.7, tcx = b.x + b.w / 2;
        s += `<g transform="rotate(-9 ${f(tcx)} ${f(ty)})">`
          + squiggle(b, ty, b.h * 0.06, WHITE, Math.max(4, b.w * 0.028))
          + `<path d="M${f(b.x + b.w * 0.24)} ${f(ty + b.h * 0.1)} Q ${f(tcx)} ${f(ty + b.h * 0.06)} ${f(b.x + b.w * 0.8)} ${f(ty + b.h * 0.11)}" fill="none" stroke="${WHITE}" stroke-width="${f(Math.max(3, b.w * 0.018))}" stroke-linecap="round"/></g>`;
        s += crown(b.x + b.w * 0.26, b.y + b.h * 0.47, Math.min(b.w, b.h) * 0.08, LIME, Math.max(3, b.w * 0.016));
        return s;
      },
    },

    clean: {
      body: '#0c0c0b', light: false,
      art(b, R, o) {
        const cx = b.x + b.w / 2, fs = b.w * 0.115;
        let s = `<rect x="${b.x - 60}" y="${f(b.y + b.h * 0.74)}" width="${b.w + 120}" height="${f(Math.max(6, b.h * 0.03))}" fill="${LIME}" transform="rotate(-10 ${cx} ${f(b.y + b.h * 0.74)})"/>`;
        s += crown(cx, b.y + b.h * 0.36, Math.min(b.w, b.h) * 0.075, LIME, Math.max(3, b.w * 0.016));
        s += `<text x="${f(cx)}" y="${f(b.y + b.h * 0.56)}" text-anchor="middle" font-family="Unbounded, Arial Black, sans-serif" font-weight="800" font-size="${f(fs)}" fill="${WHITE}" letter-spacing="1">${o.name || 'YOUR NAME'}</text>`;
        return s;
      },
    },

    splash: {
      body: WHITE, light: true,
      art(b, R) {
        let s = '';
        const centers = [[0.3, 0.3, 0.17, LIME], [0.72, 0.62, 0.2, LIME], [0.38, 0.8, 0.1, BLACK], [0.78, 0.2, 0.08, BLACK]];
        for (const [px, py, pr, col] of centers) s += splat(b.x + b.w * px, b.y + b.h * py, Math.min(b.w, b.h) * pr, col, R);
        for (let i = 0; i < 46; i++) {
          s += `<circle cx="${f(b.x + R() * b.w)}" cy="${f(b.y + R() * b.h)}" r="${f(1 + R() * Math.min(b.w, b.h) * 0.025)}" fill="${R() < 0.62 ? LIME : BLACK}"/>`;
        }
        const dx = b.x + b.w * 0.72, dy = b.y + b.h * 0.62;
        s += `<rect x="${f(dx - 5)}" y="${f(dy)}" width="10" height="${f(b.h * 0.3)}" fill="${LIME}"/><circle cx="${f(dx)}" cy="${f(dy + b.h * 0.3)}" r="7" fill="${LIME}"/>`;
        return s;
      },
    },

    idea: {
      body: WHITE, light: true,
      art(b) {
        const sw = Math.max(3, b.w * 0.018), k = Math.min(b.w, b.h);
        let s = `<rect x="${f(b.x + b.w * 0.1)}" y="${f(b.y + b.h * 0.1)}" width="${f(b.w * 0.8)}" height="${f(b.h * 0.8)}" rx="${f(k * 0.12)}" fill="none" stroke="${BLACK}" stroke-width="2" stroke-dasharray="7 7" opacity=".55"/>`;
        // star doodle
        const sx = b.x + b.w * 0.3, sy = b.y + b.h * 0.3, sr = k * 0.1;
        const pts = Array.from({ length: 10 }, (_, i) => {
          const a = -Math.PI / 2 + (i * Math.PI) / 5, r = i % 2 ? sr * 0.45 : sr;
          return `${f(sx + Math.cos(a) * r)} ${f(sy + Math.sin(a) * r)}`;
        }).join(' L ');
        s += `<path d="M${pts} Z" fill="none" stroke="${BLACK}" stroke-width="${f(sw)}" stroke-linejoin="round"/>`;
        s += crown(b.x + b.w * 0.7, b.y + b.h * 0.26, k * 0.08, BLACK, sw);
        // arrow doodle
        const ax = b.x + b.w * 0.22, ay = b.y + b.h * 0.76, bx = b.x + b.w * 0.5, by = b.y + b.h * 0.6;
        s += `<path d="M${f(ax)} ${f(ay)} Q ${f(ax + b.w * 0.05)} ${f(by - b.h * 0.02)} ${f(bx)} ${f(by)} M${f(bx - k * 0.06)} ${f(by - k * 0.03)} L ${f(bx)} ${f(by)} L ${f(bx - k * 0.05)} ${f(by + k * 0.05)}" fill="none" stroke="${BLACK}" stroke-width="${f(sw)}" stroke-linecap="round" stroke-linejoin="round"/>`;
        // the question mark — your idea goes here
        const qx = b.x + b.w * 0.68, qy = b.y + b.h * 0.7, qs = k * 0.34;
        s += `<path d="M${f(qx - qs * 0.28)} ${f(qy + qs * 0.1)} q ${f(qs * 0.3)} ${f(-qs * 0.12)} ${f(qs * 0.6)} 0" stroke="${LIME}" stroke-width="${f(qs * 0.14)}" fill="none" stroke-linecap="round"/>`;
        s += `<text x="${f(qx)}" y="${f(qy)}" text-anchor="middle" font-family="Unbounded, Arial Black, sans-serif" font-weight="900" font-size="${f(qs)}" fill="${BLACK}">?</text>`;
        return s;
      },
    },
  };

  let uid = 0;
  function render(deviceId, modeId, opts) {
    opts = opts || {};
    const d = DEVICES[deviceId], m = MODES[modeId], c = m.light ? LIGHT : DARK, b = d.box, id = 'fm' + (++uid);
    const R = rng(deviceId + ':' + modeId);
    return `<svg viewBox="0 0 400 400" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="${opts.label || ''}">
      <defs>
        <clipPath id="${id}c">${d.shapes.map((s) => shapeEl(s, '')).join('')}</clipPath>
        <linearGradient id="${id}g" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stop-color="#fff" stop-opacity="${m.light ? 0.35 : 0.12}"/><stop offset=".45" stop-color="#fff" stop-opacity="0"/>
        </linearGradient>
      </defs>
      <ellipse cx="200" cy="${b.y + b.h + 20}" rx="${f(b.w * 0.46)}" ry="11" fill="#000" opacity=".55"/>
      <g>${d.shapes.map((s) => shapeEl(s, `fill="${c.outline}" stroke="${c.outline}" stroke-width="6"`)).join('')}</g>
      <g>${d.shapes.map((s) => shapeEl(s, `fill="${m.body}"`)).join('')}</g>
      <g clip-path="url(#${id}c)">${m.art(b, R, opts)}<rect width="400" height="400" fill="url(#${id}g)"/></g>
      <g>${d.details(c)}</g>
    </svg>`;
  }

  window.FunDevices = { render, devices: Object.keys(DEVICES), modes: ['street', 'clean', 'splash', 'idea'] };
})();
